import {
	AfterViewInit,
	Component,
	Input,
	OnInit
}                        from '@angular/core';
import {
	AbstractControl,
	UntypedFormGroup
}                        from '@angular/forms';
import { BaseComponent } from '@app/core/bases/base-component/base.component';
import { IFormData }     from '@app/core/interfaces/form.interface';
import { Subject }       from 'rxjs';

export declare interface FormControlBase {
	updateRevertValue( val: any ): void;
}

@Component( {
	selector: 'app-form-control-base',
	template: '<div></div>'
} )
export class FormControlBaseComponent extends BaseComponent implements AfterViewInit, OnInit {

	private _control: AbstractControl;

	get control(): AbstractControl {
		if ( this._control ) { return this._control; }

		this._control = this.formGroup?.get( this.formControlNameOverwrite ?? this.formEntityId );
		return this._control;
	}

	@Input() addSpaceToPrevious: boolean;
	@Input() baseCssClass: { [ key: string ]: boolean };
	@Input() colSpan: number;
	@Input() config: IFormData;
	@Input() disableControl: boolean;
	@Input() errorMsg: string[];
	@Input() formControlInline = true;
	@Input() formControlNameOverwrite: string;
	@Input() formEntityId: string;
	@Input() formEntityIdOverwrite: string;
	@Input() formGroup: UntypedFormGroup;
	@Input() hideErrors: boolean;
	@Input() hideErrorDescriptions: boolean;
	@Input() isRequired: boolean;
	@Input() labelInfoInline = false;
	@Input() labelHostClassString: string;
	@Input() labelTitle: string;
	@Input() labelText: string;
	@Input() readOnly: boolean;
	@Input() set translationPathOverride( translationPath: string ) {
		this.translationPath = translationPath;
	}
	@Input() updateControlState: Subject<boolean>;


	isHovered: boolean;
	hasFocus: boolean;
	revertValue: any;
	showRevertButton: boolean;
	showClearButton: boolean;


	constructor() {
		super();
	}

	protected updateActionButtonsVisibility( controlHasValue: boolean ): void {

		/*
		 * TODO The need for using setTimeout() at this point seems to be closely
		 *  related to poor initialization timing in the FormSelectComponent
		 *  (also see comment in ErsFormSharedService.processChangedValues).
		 */
		const timeout = setTimeout( () => {
			clearTimeout( timeout );

			if ( controlHasValue ) {
				this.showClearButton = true;
				this.showRevertButton = !this.showClearButton;
				this.control.markAsTouched( { onlySelf: true } );
			} else if ( this.control.touched ) {
				this.showClearButton = false;
				this.showRevertButton = !this.showClearButton && this.revertValue;
			} else {
				this.showClearButton = false;
				this.showRevertButton = false;
			}
		}, 0 );
	}

	ngOnInit(): void {
		this.translationPath = this.translationPath ?? this.config.i18nPath;
		this.hideErrors = this.hideErrors === true;

		this.isRequired = this.isRequired ? this.isRequired : false;
		this.readOnly = this.readOnly ? this.readOnly : false;
		this.baseCssClass = this.baseCssClass ? this.baseCssClass : null;
		this.colSpan = this.colSpan ? this.colSpan : 12;

		this.config.elsterField = this.config.elsterField === true;
		this.config.elsterRequiredField = this.config.elsterRequiredField === true;
		this.config.elsterShowIndicator = this.config.elsterShowIndicator === true;
		this.config.hideLabel = this.config.hideLabel === true;
		this.config.hidePlaceholder = this.config.hidePlaceholder === true;
		this.config.required = this.config.required === true;
		this.config.showInfo = this.config.showInfo === true;
		this.config.tabindex = this.config.tabindex ? this.config.tabindex : '0';


		if ( this.control ) {
			this.revertValue = this.control.value;
			this.updateActionButtonsVisibility( !!this.control.value );
		}
	}

	ngAfterViewInit(): void {}

	clearControlValue(): void {
		this.control.setValue( null );
		this.control.markAsDirty();
		this.control.updateValueAndValidity();
	}

	revertControlValue() {
		this.control.setValue( this.revertValue );
		this.control.updateValueAndValidity();
	}

	setFocus( focus: boolean ): void {
		const timeout = setTimeout( () => {
			clearTimeout( timeout );
			this.hasFocus = focus && !this.disableControl;
		}, 0 );
	}

	setHovered( hovered: boolean ): void {
		this.isHovered = hovered && !this.disableControl;
	}

	resetControl(): void {
		if ( !this.control ) { return; }
		this.control?.reset();
		this.revertValue = null;
		this.updateActionButtonsVisibility( false );
	}
}
